module.exports = __webpack_public_path__ + "img/ac10.12cb1f58.jpg";